import * as React from 'react';
import { SwanFonts } from './fonts.component.js';
import { SwanPageMeta } from './page-meta.component.js';
import { SwanStylesheets } from './stylesheets.component.js';
import { SwanThemes } from './themes.component.js';
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
const SwanHead = _param => {
  var {
      fontNames,
      styleSheetKeys,
      themeKeys,
      renderStyleContentAsChildren
    } = _param,
    otherProps = _objectWithoutProperties(_param, ["fontNames", "styleSheetKeys", "themeKeys", "renderStyleContentAsChildren"]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SwanPageMeta, _extends({}, otherProps)), /*#__PURE__*/React.createElement(SwanFonts, _extends({
    fontNames: fontNames,
    renderStyleContentAsChildren: renderStyleContentAsChildren
  }, otherProps)), /*#__PURE__*/React.createElement(SwanStylesheets, _extends({
    styleSheetKeys: styleSheetKeys
  }, otherProps)), /*#__PURE__*/React.createElement(SwanThemes, _extends({
    themeKeys: themeKeys
  }, otherProps)));
};
export { SwanHead };